module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0147.jpg?v=2c862c88";